import { ReactTyped } from "react-typed";
import { Link } from "react-router-dom";
import "../../styles//Hero.css";

import HeroTiger from "../../assets/images/herotiger.png";

export default function Hero() {
  return (
    <div className="hero">
      <div className="hero__overlay" aria-hidden="true"></div>
      <div className="section">
        <div className="hero__grid">
          <div className="hero__content">
            <p className="hero__brand">Javelynx</p>

            <h1 className="hero__title">
              <ReactTyped
                strings={[
                  "Precision. Agility. Impact.",
                  "Fast. Secure. Scalable.",
                  "Your Vision, Our Execution.",
                ]}
                typeSpeed={80} // typing speed
                backSpeed={40} // deleting speed
                backDelay={2000} // pause before deleting
                loop // repeat forever
              />
            </h1>

            <p className="hero__subtitle">
              We combine the power of the Javelin (speed & precision) with the
              vision of the Lynx (agility & intelligence) to build secure,
              scalable systems.
            </p>

            <div className="hero__buttons">
              <a href="#contact" className="btn-primary">
                Work with us
              </a>
              <a href="#services" className="btn-outline">
                Explore services
              </a>
            </div>
          </div>

          <div className="hero__imageWrapper">
            <img
              src={HeroTiger}
              alt="Javelynx wordmark"
              className="hero__image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
